<template>
  <div class="chart-container">
    <simple-chart :options="options" :series="series" :is-loading="isLoading" name="Booking" @setChart="setChart" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

// Models
import { ApexOptions } from "@/typings/apexChartTypes";

// Components
import SimpleChart from "@/components/shared/charts/SimpleChart.vue";
import { Chart } from "@/models/api/statistics/Statistics";

@Component({
  components: {
    SimpleChart,
  },
})
export default class BookingChart extends Vue {
  get categories() {
    if (this.$store.direct.state.statistics.bookingChart != null) {
      return this.$store.direct.state.statistics.bookingChart.categories;
    }
    return [];
  }

  get series() {
    if (this.$store.direct.state.statistics.bookingChart != null) {
      return this.$store.direct.state.statistics.bookingChart.series;
    }
    return [];
  }

  get options(): ApexOptions {
    return {
      chart: {
        type: "area",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      xaxis: {
        type: "datetime",
        categories: this.categories,
        tooltip: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      noData: {
        text: "Wybierz dane",
      },
      tooltip: {
        enabled: true,
        followCursor: true,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      fill: {
        type: "solid",
        opacity: 1,
      },
      legend: {
        show: true,
        onItemClick: {
          toggleDataSeries: false,
        },
      },
    };
  }

  isLoading = false;

  setChart(param: Chart) {
    this.$store.direct.commit.statistics.setBookingChart(param);
  }
}
</script>

<style lang="scss" scoped>
.chart {
  display: flex;
  flex-direction: column;
}

.chart-container {
  border: 1px solid $container-border-color;
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  flex-grow: 1;
  background: white;
}
</style>
